/**
 * `<quick-add>` custom element (roadmap v1.1, quick add from the card).
 *
 * Wraps the single-variant product form inside a product card. Intercepts the
 * submit, posts to /cart/add.js, confirms inline in the card's live region and
 * reveals the pre-rendered cart link. Without JS the form posts natively.
 *
 * Shares `AddToCartBase` (assets/add-to-cart-base.js) with `<product-form>`
 * and `<quick-order>`.
 */
class QuickAdd extends AddToCartBase {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.statusEl = this.querySelector('[data-quick-add-status]');
    this.messageEl = this.querySelector('[data-quick-add-message]');
    this.cartLink = this.querySelector('[data-quick-add-link]');
    this.successMessage = this.dataset.successMessage || '';
  }

  connectedCallback() {
    if (!this.form) return;
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(event) {
    if (!event.submitter || event.submitter.name !== 'add') return;
    event.preventDefault();
    this.addToCart({
      context: 'quick-add',
      lines: [{ merchandiseId: this.form.elements.id.value, quantity: this.form.elements.quantity.value }],
      body: new URLSearchParams(new FormData(this.form)).toString(),
      target: this.form,
      successMessage: this.successMessage,
      button: event.submitter
    });
  }

  setStatus(message, isError) {
    if (!this.messageEl) return;
    this.messageEl.textContent = message;
    this.statusEl.classList.toggle('product-card__status--error', Boolean(isError));
    if (this.cartLink) this.cartLink.hidden = Boolean(isError) || message === '';
  }
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', QuickAdd);
}
